// extracted by mini-css-extract-plugin
export default {"heroContainer":"HeroSection_heroContainer__GOmV5","heroSection":"HeroSection_heroSection__HGwVp","text":"HeroSection_text__nMp7M"};